import React, { useEffect, useState, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import moment from "moment";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import eye from '../../assets/images/eye.svg';
import eye from "../../assets/images/eye.png";
import eyeview from "../../assets/images/view.png";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/css/style.css";
import "../../assets/css/inbox.css";
import "../../assets/css/responsive.css";

const W4South = ({ review, data, fetchSections }) => {
  console.log(review, data);
  const params = useParams();
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const [tempId, setTempId] = useState(0);
  const [fields, setFields] = useState([]);
  const [formId, setFormId] = useState(data?.id);
  const [formData, setFormData] = useState([]);
  const [isReview, setIsReview] = useState(review);
  const [error, setError] = useState(false);
  const [fileName, setFilename] = useState("");

  useEffect(() => {
    // getFields();
    setData();
    getFileName();
    if (location.state?.tempId !== null) {
      setTempId(location?.state?.tempId);
    }
  }, [data]);

  // set value to formData
  const setData = () => {
    let arr = [];
    data?.fields?.map((item) => {
      let obj = {};
      if (item.field_label === "scw4_ssno") {
        obj = {
          label: item.field_label,
          answer: item.interviewee_answer,
          isShow: false,
        };
      } else {
        obj = {
          label: item.field_label,
          answer: item.interviewee_answer,
        };
      }
      arr.push(obj);
    });
    console.log(arr);
    setFormData(arr);
  };

  const getFields = async () => {
    setLoader(true);
    const obj = {
      template_type: "W4Sc-form",
    };
    await ApiHelper.post(API.getFields, obj)
      .then((resData) => {
        console.log(resData);
        setFields(resData?.data?.fields);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const getFileName = async () => {
    setLoader(true);
    const obj = {
      intervieweeid: params?.id,
      formid: data?.id,
    };
    await ApiHelper.post(API.downloadForm, obj)
      .then((resData) => {
        console.log(resData);
        if (resData?.data?.success === true) {
          setFilename(resData?.data?.i9Doc);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  //update Field values
  const onTextAreaBlur = async (e) => {
    console.log(e);
    setLoader(true);
    const obj = {
      form_id: formId,
      field_label: e.target.name,
      interviewee_answer: e.target.value,
    };
    await ApiHelper.post(API.updateFields, obj)
      .then((resData) => {
        console.log(resData);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  // display value
  const generatevalue = (fieldName) => {
    let obj = formData.filter((item) => item?.label === fieldName);
    // console.log(obj)
    if (obj[0]?.answer === null) {
      return "";
    } else return obj[0]?.answer;
  };

  // onchange
  const onTextareaChange = (e) => {
    const updatedItems = formData.map((item) => {
      if (item.label === e.target.name) {
        return { ...item, answer: e.target.value };
      }
      return item;
    });
    setFormData(updatedItems);
  };

  //submit form
  const submitForm = async (e) => {
    e.preventDefault();
    setLoader(true);
    let err = false;
    for (let i = 0; i < formData.length; i++) {
      if (
        formData[i]?.label === "scw4_first_name" ||
        formData[i]?.label === "scw4_last_name" ||
        formData[i]?.label === "scw4_address" ||
        formData[i]?.label === "scw4_city" ||
        formData[i]?.label === "scw4_state" ||
        formData[i]?.label === "scw4_marrital_status" ||
        formData[i]?.label === "scw4_zip" ||
        formData[i]?.label === "scw4_total_allowance" ||
        formData[i]?.label === "scw4_claim_exemption"
        // formData[i]?.label==="w4_date"
      ) {
        if (formData[i]?.answer === "" || formData[i]?.answer === null) {
          err = true;
        }
      }
      if (formData[i]?.label === "scw4_ssno") {
        console.log(typeof formData[i]?.answer);
        let ssnRegex = /^\d{3}-?\d{2}-?\d{4}$/.test(formData[i]?.answer);
        console.log(ssnRegex);
        if (
          formData[i]?.answer === "" ||
          formData[i]?.answer === null ||
          ssnRegex === false
        ) {
          err = true;
        }
      }
      if (isReview) {
        if (
          formData[i]?.label === "scw4_employer_name_address" ||
          formData[i]?.label === "scw4_femployer_irst_day_employment"
        ) {
          if (formData[i]?.answer === "" || formData[i]?.answer === null) {
            err = true;
          }
        }
      }
    }
    console.log(err);
    setError(err);
    const ChatbotId = localStorage.getItem("candidateChatbotId");
    let user = JSON.parse(localStorage.getItem("UserData"));
    if (err === true) {
      toast("Form Not Completed!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setLoader(false);
    } else {
      if (!isReview) {
        const formobj = {
          form_id: formId,
          field_label: "scw4_date",
          interviewee_answer: moment().format("MMMM DD, YYYY"),
        };
        await ApiHelper.post(API.updateFields, formobj)
          .then((resData) => {
            console.log(resData);
          })
          .catch((err) => {
            setLoader(false);
            console.log(err);
          });
      }
      let obj = {
        formid: data.id,
        interviewid: params.id,
        template_id: params.tempid !== undefined ? params.tempid : 0,
      };
      let formData = {
        chatbotid: ChatbotId,
        intervieweeid: params?.id,
        formid: data?.id,
        userId: user?.id,
        template_id:
          tempId !== 0
            ? tempId
            : location.state?.tempId !== null
            ? location.state?.tempId
            : 0,
      };
      await ApiHelper.post(
        isReview ? API.employerConfirm : API.confirmForm,
        isReview ? formData : obj
      )
        .then((resData) => {
          console.log(resData);
          if (resData.data.success === true) {
            fetchSections(params.id);
            let filepath = API.legalFormsView + resData?.data?.pdfurl;
            if (!isReview && resData?.data?.pdfurl !== "") {
              const link = document.createElement("a");
              link.href = filepath;
              link.download = "avenu";
              link.target = "_blank";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
            toast("Form Completed!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });

            // if(item.section_forms?.length === i + 1)
            //  {
            //     setNextInd(index+1)
            //  }
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
  };

  return (
    <div>
      <div className="mx-auto" style={{ width: "95%" }}>
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="me-3 mb-4 rev-padd-tap">
              <div>
                <p className="head-l">
                  <span>STATE OF SOUTH CAROLINA DEPARTMENT OF REVENUE </span>
                </p>
                <p className="head-l">
                  <strong>
                    SOUTH CAROLINA EMPLOYEE'S WITHHOLDING ALLOWANCE CERTIFICATE.
                  </strong>
                </p>
              </div>
            </div>

            <p className="para-fonts">
              <strong>
                Give this form to your employer. Keep the worksheets for your
                records. The SCDOR may review any allowances and exemptions
                claimed. Your employer may be required to send a copy of this
                form to the SCDOR.
              </strong>
            </p>
            <p className="para-fonts">
              <strong>Part I: Employee Information</strong>
            </p>
            <form>
              <div class="row g-3">
                <div class="col-md-6">
                  <label for="your-name" class="form-label">
                    1. First name and middle initial{" "}
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("scw4_first_name") === "" ||
                          generatevalue("scw4_first_name") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="scw4_first_name"
                    rows="5"
                    value={generatevalue("scw4_first_name")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  />
                </div>

                <div class="col-md-6">
                  <label for="your-surname" class="form-label">
                    Last name{" "}
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("scw4_last_name") === "" ||
                          generatevalue("scw4_last_name") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="scw4_last_name"
                    rows="5"
                    value={generatevalue("scw4_last_name")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  />
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    2. Social security number
                  </label>
                  <div class="input-group-append pass-div-width">
                    <input
                      type={formData[5]?.isShow === true ? "text" : "password"}
                      class="form-control pass-inpt"
                      placeholder="Enter text here"
                      style={{
                        border:
                          error === true &&
                          (generatevalue("scw4_ssno") === "" ||
                            generatevalue("scw4_ssno") === null ||
                            /^\d{3}-?\d{2}-?\d{4}$/.test(
                              generatevalue("scw4_ssno")
                            ) === false)
                            ? "1px solid red"
                            : null,
                        borderRight: "none",
                      }}
                      id="your-message"
                      name="scw4_ssno"
                      rows="5"
                      value={generatevalue("scw4_ssno")}
                      onBlur={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextAreaBlur(e);
                      }}
                      onChange={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextareaChange(e);
                      }}
                    />
                    <button
                      type="button"
                      class="btn eye-bttn"
                      data-toggle="password"
                      style={{
                        border:
                          error === true &&
                          (generatevalue("scw4_ssno") === "" ||
                            generatevalue("scw4_ssno") === null ||
                            /^\d{3}-?\d{2}-?\d{4}$/.test(
                              generatevalue("scw4_ssno")
                            ) === false)
                            ? "1px solid red"
                            : null,
                        borderLeft: "none",
                      }}
                      onClick={() => {
                        let data = [...formData];
                        if (data) {
                          data[5].isShow = !data[5].isShow;
                        }
                        setFormData(data);
                      }}
                    >
                      <img
                        src={formData[5]?.isShow ? eyeview : eye}
                        alt="test"
                        className="menu_icon eye-img"
                      />
                    </button>
                  </div>
                  {/* <textarea class="form-control text-class" style={{ border: error===true && (generatevalue("scw4_ssno") === "" || generatevalue("scw4_ssno") === null || /^\d{3}-?\d{2}-?\d{4}$/.test(generatevalue("scw4_ssno"))===false) ? '1px solid red' : null}} id="your-message" name="scw4_ssno" rows="5" value={generatevalue("scw4_ssno")} onBlur={(e)=>{(!isReview && data?.completed_status===0) && onTextAreaBlur(e)}} onChange={(e)=>{(!isReview && data?.completed_status===0) && onTextareaChange(e) }}  /> */}
                </div>

                <div class="col-md-6">
                  <label for="your-email" class="form-label">
                    Address
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("scw4_address") === "" ||
                          generatevalue("scw4_address") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="scw4_address"
                    rows="5"
                    value={generatevalue("scw4_address")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  />
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    City{" "}
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("scw4_city") === "" ||
                          generatevalue("scw4_city") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="scw4_city"
                    rows="5"
                    value={generatevalue("scw4_city")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  />
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    State
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("scw4_state") === "" ||
                          generatevalue("scw4_state") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="scw4_state"
                    rows="5"
                    value={generatevalue("scw4_state")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  />
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    ZIP{" "}
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("scw4_zip") === "" ||
                          generatevalue("scw4_zip") === null ||
                          /^\d{5}(?:[-\s]\d{4})?$/.test(
                            generatevalue("scw4_zip")
                          ) === false)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="scw4_zip"
                    rows="5"
                    value={generatevalue("scw4_zip")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  />
                </div>

                <div class="col-12">
                  <p className="para-fonts">3.</p>
                  <input
                    type="radio"
                    class="form-check-input radio-sizee"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("scw4_marrital_status") === "" ||
                          generatevalue("scw4_marrital_status") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    name="scw4_marrital_status"
                    value="Single"
                    onChange={(e) => {
                      if (!isReview && data?.completed_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                    checked={generatevalue("scw4_marrital_status") === "Single"}
                  />
                  <label for="vehicle1" className=" w4form-l">
                    {" "}
                    Single
                  </label>
                </div>

                <div class="col-12">
                  <input
                    type="radio"
                    class="form-check-input radio-sizee"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("scw4_marrital_status") === "" ||
                          generatevalue("scw4_marrital_status") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    name="scw4_marrital_status"
                    value="Married"
                    onChange={(e) => {
                      if (!isReview && data?.completed_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                    checked={
                      generatevalue("scw4_marrital_status") === "Married"
                    }
                  />
                  <label for="vehicle1" className=" w4form-l">
                    Married{" "}
                  </label>
                </div>

                <div class="col-12">
                  <input
                    type="radio"
                    class="form-check-input radio-sizee"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("scw4_marrital_status") === "" ||
                          generatevalue("scw4_marrital_status") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    name="scw4_marrital_status"
                    value="Married, but withhold at higher Single rate"
                    onChange={(e) => {
                      if (!isReview && data?.completed_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                    checked={
                      generatevalue("scw4_marrital_status") ===
                      "Married, but withhold at higher Single rate"
                    }
                  />
                  <label for="vehicle1" className=" w4form-l">
                    Married, but withhold at higher Single rate
                  </label>
                </div>

                <div class="col-12">
                  <p className="para-fonts">
                    4. Check if your last name is different on your Social
                    Security card.
                  </p>
                  <input
                    type="checkbox"
                    class="form-check-input radio-sizee"
                    name="scw4_last_name_diffrent"
                    value={
                      generatevalue("scw4_last_name_diffrent") === ""
                        ? "false"
                        : generatevalue("scw4_last_name_diffrent") === "false"
                        ? "true"
                        : "false"
                    }
                    onChange={(e) => {
                      if (data?.employer_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                    checked={
                      generatevalue("scw4_last_name_diffrent") === "true"
                    }
                  />
                  <label for="vehicle1" className=" w4form-l">
                    For a replacement card, contact the Social Security Admin at
                    1-800-772-1213
                  </label>
                </div>

                <div class="col-md-6">
                  <p className="para-fonts">
                    <span className="mul-txt">
                      5. Total number of allowances (from the applicable
                      worksheet on page 3)
                    </span>
                    &nbsp;
                  </p>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("scw4_total_allowance") === "" ||
                          generatevalue("scw4_total_allowance") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="scw4_total_allowance"
                    rows="5"
                    value={generatevalue("scw4_total_allowance")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  />
                </div>

                <div class="col-md-6">
                  <p className="para-fonts">
                    <span className="mul-txt">
                      6. Additional amount, if any, to withhold from each
                      paycheck . $
                    </span>
                    &nbsp;
                  </p>
                  <textarea
                    class="form-control text-class"
                    id="your-message"
                    name="scw4_additional_amount"
                    rows="5"
                    value={generatevalue("scw4_additional_amount")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  />
                </div>

                <p className="para-fonts">
                  7. I claim exemption from withholding for 2023. Check the box
                  for the exemption reason and write Exempt on line 7{" "}
                </p>

                <div class="col-12">
                  <input
                    type="radio"
                    class="form-check-input radio-sizee"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("scw4_claim_exemption") === "" ||
                          generatevalue("scw4_claim_exemption") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    name="scw4_claim_exemption"
                    value="For tax year 2022, I had a right to a refund of all South Carolina Income Tax withheld because I had no tax liability, and for tax year 2023 I expect a refund of all South Carolina Income Tax withheld because I expect to have no tax liability."
                    onChange={(e) => {
                      if (!isReview && data?.completed_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                    checked={
                      generatevalue("scw4_claim_exemption") ===
                      "For tax year 2022, I had a right to a refund of all South Carolina Income Tax withheld because I had no tax liability, and for tax year 2023 I expect a refund of all South Carolina Income Tax withheld because I expect to have no tax liability."
                    }
                  />
                  <label for="vehicle1" className=" w4form-l sounth">
                    For tax year 2022, I had a right to a refund of all South
                    Carolina Income Tax withheld because I had no tax liability,
                    and for tax year 2023 I expect a refund of all South
                    Carolina Income Tax withheld because I expect to have no tax
                    liability.
                  </label>
                </div>

                <div class="col-12">
                  <input
                    type="radio"
                    class="form-check-input radio-sizee"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("scw4_claim_exemption") === "" ||
                          generatevalue("scw4_claim_exemption") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    name="scw4_claim_exemption"
                    value="I elect to use the same state of residence for tax purposes as my military servicemember spouse. I have provided my employer with a copy of my current military ID card and a copy of my spouse's latest Leave and Earning Statement (LES)."
                    onChange={(e) => {
                      if (!isReview && data?.completed_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                    checked={
                      generatevalue("scw4_claim_exemption") ===
                      "I elect to use the same state of residence for tax purposes as my military servicemember spouse. I have provided my employer with a copy of my current military ID card and a copy of my spouse's latest Leave and Earning Statement (LES)."
                    }
                  />
                  <label for="vehicle1" className=" w4form-l sounth">
                    I elect to use the same state of residence for tax purposes
                    as my military servicemember spouse. I have provided my
                    employer with a copy of my current military ID card and a
                    copy of my spouse's latest Leave and Earning Statement
                    (LES).
                  </label>
                </div>

                {generatevalue("scw4_claim_exemption") ===
                  "I elect to use the same state of residence for tax purposes as my military servicemember spouse. I have provided my employer with a copy of my current military ID card and a copy of my spouse's latest Leave and Earning Statement (LES)." && (
                  <div class="col-md-6">
                    <p className="para-fonts">
                      <span className="mul-txt">State of domicile: </span>&nbsp;
                    </p>
                    <textarea
                      class="form-control text-class"
                      id="your-message"
                      name="scw4_state_domicilie"
                      rows="5"
                      value={generatevalue("scw4_state_domicilie")}
                      onBlur={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextAreaBlur(e);
                      }}
                      onChange={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextareaChange(e);
                      }}
                    />
                  </div>
                )}

                <div class="col-md-12">
                  <div className="form-check">
                    {/* <input className="form-check-input" type="checkbox" value="" /> */}
                    <label
                      className="form-check-label check-tetxz"
                      htmlFor="flexCheckDefault"
                    >
                      Under penalty of law, I certify that this information is
                      correct, true, and complete to the best of my knowledge.
                      Employees signature (required)
                    </label>
                  </div>
                </div>

                <div class="col-6">
                  <div class="form-floating wraper minH mb-3">
                    <input
                      type="text"
                      class="form-control signs"
                      id="signHereInput"
                      placeholder="Sign"
                      style={{
                        border:
                          error === true &&
                          (generatevalue("scw4_signature") === "" ||
                            generatevalue("scw4_signature") === null)
                            ? "1px solid red"
                            : null,
                      }}
                      name="scw4_signature"
                      rows="5"
                      value={generatevalue("scw4_signature")}
                      onBlur={(e) => {
                        if (data?.employer_status === 0) {
                          onTextAreaBlur(e);
                        }
                      }}
                      onChange={(e) => {
                        if (data?.employer_status === 0) {
                          onTextareaChange(e);
                        }
                      }}
                    />
                    <label for="signHereInput" class=" font-enter-color">
                      Sign Here
                    </label>
                  </div>
                </div>

                <div class="col-6">
                  <div class="form-floating minH mb-3">
                    <input
                      class="form-control"
                      placeholder="Date"
                      name="scw4_date"
                      value={
                        generatevalue("scw4_date") === "" ||
                        generatevalue("scw4_date") === undefined
                          ? moment().format("MMMM DD, YYYY")
                          : generatevalue("scw4_date")
                      }
                    />
                    <label for="dateInput" class=" font-enter-color">
                      Date
                    </label>
                  </div>
                </div>

                {/* <div class="col-md-6">
           <p className='para-fonts'><span className='mul-txt'>Date: </span>&nbsp;</p>   
           <textarea class="form-control text-class" id="your-message" />
          </div> */}
                {isReview && (
                  <>
                    <p className="para-fonts">
                      <strong>Part II: Employer Information</strong>
                    </p>
                    <p className="para-fonts">
                      Complete box 8 and box 10 if sending to the SCDOR.
                      Complete box 8, box 9, and box 10 if sending to the State
                      Directory of New Hires.
                    </p>

                    <div class="col-md-6">
                      <p className="para-fonts">
                        <span className="mul-txt">
                          8. Employer’s name and address{" "}
                        </span>
                        &nbsp;
                      </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        style={{
                          border:
                            error === true &&
                            (generatevalue("scw4_employer_name_address") ===
                              "" ||
                              generatevalue("scw4_employer_name_address") ===
                                null)
                              ? "1px solid red"
                              : null,
                        }}
                        name="scw4_employer_name_address"
                        rows="5"
                        value={generatevalue("scw4_employer_name_address")}
                        onBlur={(e) => {
                          if (data?.employer_status === 0) {
                            onTextAreaBlur(e);
                          }
                        }}
                        onChange={(e) => {
                          if (data?.employer_status === 0) {
                            onTextareaChange(e);
                          }
                        }}
                      />
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">
                        <span className="mul-txt">
                          9. First date of employment{" "}
                        </span>
                        &nbsp;
                      </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        style={{
                          border:
                            error === true &&
                            (generatevalue(
                              "scw4_femployer_irst_day_employment"
                            ) === "" ||
                              generatevalue(
                                "scw4_femployer_irst_day_employment"
                              ) === null)
                              ? "1px solid red"
                              : null,
                        }}
                        name="scw4_femployer_irst_day_employment"
                        rows="5"
                        value={generatevalue(
                          "scw4_femployer_irst_day_employment"
                        )}
                        onBlur={(e) => {
                          if (data?.employer_status === 0) {
                            onTextAreaBlur(e);
                          }
                        }}
                        onChange={(e) => {
                          if (data?.employer_status === 0) {
                            onTextareaChange(e);
                          }
                        }}
                      />
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">
                        <span className="mul-txt">
                          10. Employer identification number (EIN){" "}
                        </span>
                        &nbsp;
                      </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="scw4_employer_EIN"
                        rows="5"
                        value={generatevalue("scw4_employer_EIN")}
                        onBlur={(e) => {
                          if (data?.employer_status === 0) {
                            onTextAreaBlur(e);
                          }
                        }}
                        onChange={(e) => {
                          if (data?.employer_status === 0) {
                            onTextareaChange(e);
                          }
                        }}
                      />
                    </div>
                  </>
                )}

                {data.completed_status === 0 && !isReview && (
                  <div className="col-lg-12  align-items-center justify-content-end">
                    <div className="form-floating mb-3 justify-content-end wraper">
                      <button
                        className="submits-btn rounded p-2"
                        onClick={(e) => {
                          submitForm(e);
                        }}
                      >
                        {/* {item.section_forms?.length === i + 1 ? 'Submit Form' : 'Next Form'}  */}
                        Submit Form
                      </button>
                    </div>
                  </div>
                )}

                {data?.completed_status === 1 &&
                  data.employer_status === 0 &&
                  isReview && (
                    <div className="col-lg-12  align-items-center justify-content-end">
                      <div className="form-floating mb-3 justify-content-end wraper">
                        <button
                          className="submits-btn rounded p-2"
                          onClick={(e) => {
                            e.preventDefault();
                            submitForm(e);
                          }}
                        >
                          {" "}
                          Confirm Form{" "}
                        </button>
                      </div>
                    </div>
                  )}

                {data?.employer_status === 1 && isReview && fileName !== "" && (
                  <div className="col-lg-12  align-items-center justify-content-end">
                    <div className="form-floating mb-3 justify-content-end wraper">
                      <button
                        className="submits-btn rounded p-2 sub-bttn-right-sides"
                        onClick={(e) => {
                          e.preventDefault();
                          let filepath = API.legalFormsView + fileName;
                          if (fileName !== "") {
                            const link = document.createElement("a");
                            link.href = filepath;
                            link.download = "avenu";
                            link.target = "_blank";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }
                        }}
                      >
                        Download{" "}
                      </button>

                      {/* <button className='submits-btn rounded p-2 sub-bttn-right-sides' 
                                                                    onClick={(e) => { submitForm(e, 'Updated') }}> Update Form </button> */}
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default W4South;
